import { render, staticRenderFns } from "./ContactRequestNotification.vue?vue&type=template&id=656d5cd9&lang=pug&"
import script from "./ContactRequestNotification.vue?vue&type=script&lang=js&"
export * from "./ContactRequestNotification.vue?vue&type=script&lang=js&"
import style0 from "./ContactRequestNotification.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports